<label [for]="id">{{ label }}</label>
<div class="bciti-time-input-wrap">
  <input
    [id]="id"  
    type="time"
    [value]="value"
    [disabled]="disabled"
    [class.validation]="validation"
    [class.pristine]="pristine"
    [class.dirty]="dirty"
    [class.touched]="touched"
    [class.invalid]="invalid"
    [class.valid]="valid"
    (change)="change($event.target.value)"
    [max]="max"
    [min]="min"
    (blur)="onTouched()" />
    <span matSuffix class="icon-clock"></span>
</div>
<div *ngIf="!disableMessages" class="messages">
  <ng-content selector="app-form-error"></ng-content>
  <ng-content selector="app-form-success"></ng-content>
</div>
